import { render, staticRenderFns } from "./promotion-forecasting.vue?vue&type=template&id=580dd98c&scoped=true"
import script from "./promotion-forecasting.vue?vue&type=script&lang=js"
export * from "./promotion-forecasting.vue?vue&type=script&lang=js"
import style0 from "./promotion-forecasting.vue?vue&type=style&index=0&id=580dd98c&prod&scoped=true&lang=scss"
import style1 from "./promotion-forecasting.vue?vue&type=style&index=1&id=580dd98c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580dd98c",
  null
  
)

export default component.exports